import type { LTCaseUserOption } from "../enum/LTCaseUserOption";

/**
 * An article the build requires by name is not in the option database (for
 * example it was deleted under „Optionen“). Callers recognise it by class and
 * read the kind and name from its fields, never from the message.
 */
export class MissingOptionError extends Error {
  public readonly kind: LTCaseUserOption;
  public readonly optionName: string;

  constructor(kind: LTCaseUserOption, optionName: string) {
    super(`Option ${kind} "${optionName}" is missing from the option database`);
    this.name = "MissingOptionError";
    this.kind = kind;
    this.optionName = optionName;
  }
}
